<template>
  <div class="chatvisa-frame-recommend">
    <div class="chatvisa-recommend-header">
      <div class="chatvisa-frame-recommend-left">你可能想了解如下内容：</div>
      <div class="chatvisa-frame-recommend-right">
        <img
          class="icon-close"
          @click="$emit('close')"
          src="https://o.666visa.cn/static/ssqpeer/chatvisa/chatvisa-close.png"
          alt=""
        />
      </div>
    </div>
    <div class="handle-change" @click="getQuestionList(true)">
      <img
        class="icon-close"
        src="https://o.666visa.cn/static/ssqpeer/chatvisa/icon_change.png"
        alt=""
      />
      <div class="change-text">换一换</div>
    </div>
    <div class="recommend-list">
      <div
        class="recommend-li"
        v-for="(item, index) in questionList"
        :key="index"
        @click="clickQuestion(item)"
      >
        <div class="recommend-li-text">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import User from '@/libs/user';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {},
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    countryId: Number,
  },
  data() {
    return {
      has_more: false,
      questionList: [],
      // countryName: '',
    };
  },
  computed: {
    ...mapState('chatVisa', ['chatVisaFrameBurialPoint']),
  },
  created() {
    // if (this.countryId) {
    //   this.getCountryInfo();
    // }
    this.getQuestionList();
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    // async getCountryInfo() {
    //   const countryInfo = await Http.post('/sys/visa_country_query', {
    //     visa_country_id: this.countryId,
    //   });
    //   this.countryName = countryInfo.country;
    // },
    async getQuestionList(isChange) {
      const params = {
        country_id: this.countryId,
      };
      if (isChange && this.questionList.length) {
        params.last_pos = this.questionList[this.questionList.length - 1].pos;
      }
      const res = await Http.post(
        '/sys/visa_chat_question_brief_query',
        params,
      );
      this.questionList = res.page_data;
      this.has_more = res.has_more;
    },
    clickQuestion(item) {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX();
        return;
      }
      Http.post('/visa_chat_question_click', {
        visa_chat_question_id: item.visa_chat_question_id,
      });
      this.$emit('send-question', item.content);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.chatvisa-frame-recommend {
  width: 336px;
  // height: 208px;
  padding: 12px;
  background: #f6f8fe;
  border-radius: 4px;
  margin: 16px auto;

  .chatvisa-recommend-header {
    display: flex;
    justify-content: space-between;

    .chatvisa-frame-recommend-left {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      flex: 1;
    }

    .chatvisa-frame-recommend-right {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      min-width: 100px;
      height: 20px;
      align-items: center;
      .icon-close {
        display: block;
        width: 16px;
        height: 16px;
      }
    }
  }

  .handle-change {
    width: 60px;
    display: flex;
    justify-content: flex-start;
    gap: 6px;
    height: 20px;
    align-items: center;
    cursor: pointer;
    margin-top: 5px;
    .icon-close {
      display: block;
      width: 16px;
      height: 16px;
    }

    .change-text {
      font-size: 12px;
      color: #599fff;
    }
  }

  .recommend-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;

    .recommend-li {
      padding: 8px 10px;
      width: 312px;
      max-height: 60px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e9eef2;
      cursor: pointer;

      .recommend-li-text {
        font-size: 14px;
        color: #2f333d;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // word-break: break-all;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/component-external/components/chatvisa-frame-recommend.vue